import { createContext } from 'react'

import { Modules } from './types'

const context = createContext<Modules | undefined>(undefined)

export default context
